import React, { Component } from 'react';

class HistoryExpandable extends Component {
    constructor(props) {
        super(props);
        this.props = props;
    }

    render() {
        return (
            <div>
                {this.props.dataR[0].map((v, k) => {
                    let classResult = "";
                    // if (this.props.result == "true") {
                        if (v['bets'][0]['result'] == 1) {
                            classResult = " text-success font-weight-bold "
                        } else if(v['bets'][0]['result'] == null){
                        
                        } else {
                            classResult = " text-danger font-weight-bold "
                        }
                    // }
                    return (
                        <div key={k} className="bet-table-section py-2">
                            <div>
                                <span className={classResult}>{v['bets'][0]['name']}</span>

                                <span className="float-right odds">{v['bets'][0]['odds']}</span>
                            </div>
                            <div>{v['match_name']}</div>
                            <div>
                                <span>{v['market_name']}</span>
                                <span className="float-right">{v['match_time']}</span>

                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default HistoryExpandable;



// WEBPACK FOOTER //
// ./components/BetTable/historyExpandable.js